<template>
  <section>
    <PublicNavigation :showForm="showForm" />
    <!-- Main header -->
    <section class="main-header">
      <div class="container d-flex align-items-center">
        <h1>Connecting IT specialists <span>with the hottest jobs</span></h1>
        <form
          @submit.prevent
          class="form-inline d-flex align-items-center justify-content-between base-search-two"
        >
          <div class="col-1-left">
            <v-select
              v-model="keywords"
              placeholder="Competencies"
              label="name"
              :options="getCompetencesFilterList"
              :reduce="competence => competence"
              :clearable="true"
              multiple
            >
              <template v-slot:no-options="{ search, searching }">
                <template v-if="searching && search.length >= 3">
                  No results found for <em>{{ search }}</em
                  >.
                </template>
                <div style="opacity: 0.5" v-else>Please type at least 3 characters</div>
              </template>
            </v-select>
          </div>

          <div class="col-2-middle d-flex align-items-center">
            <v-select
              @search="fetchOptions"
              v-model="sendLocation"
              class="mr-1 w-50"
              label="name"
              placeholder="Location"
              aria-label="location"
              aria-describedby="location-input"
              :options="[...locationsOptions]"
              :reduce="location => location"
              :clearable="false"
              multiple
            >
              <template v-slot:no-options>
                <div style="opacity: 0.5">Please type at least 3 characters</div>
              </template>
            </v-select>
            <button style="flex: 1" @click="searchJob()" class="btn btn-secondary">
              Search Jobs
            </button>
          </div>
        </form>
      </div>
    </section>
    <!-- Main header end -->
    <section class="latest-ads">
      <div class="container">
        <div class="row">
          <!-- Left Col -->
          <div class="col-md-8">
            <h2>Latest jobs</h2>
            <!-- Single Job Post -->
            <div v-for="jobAd in jobAds" :key="jobAd.id" class="single d-flex align-items-center">
              <span v-if="!jobAd.anonymize">
                <img
                  :src="`https://jobshark.eu/storage/employers/logos/${jobAd.photo}`"
                  v-if="
                    jobAd.photo !== null && jobAd.photo !== 'default.png' && jobAd.photo !== 'null'
                  "
                  :title="jobAd.title"
                />
                <img :src="require(`../../public/img/comstream.svg`)" v-else :title="jobAd.title" />
              </span>
              <img
                v-else
                :src="require(`../../public/img/homepage/customer-logos/comstream-logo.png`)"
                :alt="jobAd.title"
              />
              <div class="job-info">
                <router-link
                  :to="{
                    name: 'preview-job-ad',
                    params: { slug: jobAd.slug },
                  }"
                  >{{ jobAd.title }}</router-link
                >
                <a href="#">{{ jobAd.employer_name }}</a>
              </div>
              <div v-if="jobAd.address" class="location">
                <i class="fas fa-map-marker-alt"></i>
                <span>{{ jobAd.address.city.name }}</span>
                <span>{{ jobAd.address.country.name }}</span>
              </div>
              <div class="location">
                <i class="fas fa-handshake"></i>
                <span>{{ employmentType(jobAd.employment_type) }}</span>
              </div>
              <div
                v-if="() => jobAd.hasOwnProperty('required_competences')"
                class="tagline ml-auto"
              >
                <a
                  v-for="competence in jobAd.required_competences.slice(0, 4)"
                  :key="competence.id"
                  href="#"
                  >{{ competence.name }}</a
                >
              </div>
            </div>
            <!-- End Single Job Post -->
          </div>
          <!-- End Left Col -->
          <!-- Right col -->
          <div class="col-md-4">
            <h2>Promoted jobs</h2>

            <router-link
              v-for="promoted in promotedJobAds"
              :key="promoted.id"
              class="single-promoted d-flex"
              :to="{
                name: 'preview-job-ad',
                params: { slug: promoted.slug },
              }"
            >
              <span v-if="!promoted.anonymize">
                <img
                  :src="`https://jobshark.eu/storage/employers/logos/${promoted.photo}`"
                  v-if="
                    promoted.photo !== null &&
                      promoted.photo !== 'default.png' &&
                      promoted.photo !== 'null'
                  "
                  :title="promoted.title"
                />
                <img
                  :src="require(`../../public/img/comstream.svg`)"
                  v-else
                  :title="promoted.title"
                />
              </span>
              <img
                v-else
                :src="require(`../../public/img/homepage/customer-logos/comstream-logo.png`)"
                :alt="promoted.title"
              />
              <div class="single-job-info d-flex align-items-center">
                <span>{{ promoted.title }}</span>
                <span v-if="promoted && promoted.address && promoted.address.city" class="details"
                  >{{ promoted.address.city.name }}, {{ promoted.address.country.name }}</span
                >
              </div>
            </router-link>
          </div>
          <!-- End right col -->
        </div>
      </div>
    </section>
    <!-- Middle Orange Section -->
    <section class="mid-section">
      <div class="container">
        <h2>A better way to match candidates and employers</h2>
        <p>
          We connect IT professionals with job opportunities from the best employers. And, because
          we believe that advertising should be free, employers can post their vacancies at no cost
          and choose from additional boosters to supercharge their ad.
        </p>
        <div class="d-flex justify-content-around mobile-wrap">
          <div class="text-box d-flex" @click="showFormEvent('candidate')">
            <img src="../../public/img/homepage/icon-user.png" alt="user" />
            <div class="text">
              <h3>Job seekers</h3>
              <p>
                Register an account and receive job opportunities that are tailored to your skills
                and goals.
              </p>
            </div>
            <span><i class="fas fa-angle-double-right"></i></span>
          </div>

          <div @click="showFormEvent('employer')" class="text-box d-flex">
            <img src="../../public/img/homepage/icon-resume.png" alt="user" />
            <div class="text">
              <h3>Employers</h3>
              <p>
                Post jobs for free and boost their effectiveness with additional services for even
                better matching.
              </p>
            </div>
            <span><i class="fas fa-angle-double-right"></i></span>
          </div>
        </div>
      </div>
    </section>
    <!-- End of orange section -->
    <!-- Brands Sections -->
    <section class="brands">
      <div class="container">
        <h3>Top hiring companies</h3>
        <carousel
          :autoplay="true"
          :nav="false"
          :items="8"
          :margin="40"
          :responsive="{
            0: { items: 2, nav: false },
            576: { items: 3, nav: false },
            768: { items: 3, nav: false },
            992: { items: 4, nav: false },
            1200: { items: 7, nav: false },
          }"
        >
          <img
            v-for="brand in brands"
            :key="brand.id"
            class="lgx-logo-img"
            :src="require(`../../public/img/homepage/customer-logos/${brand.src}`)"
            style="max-width: 350px; max-height: 350px"
            :alt="brand.alt"
            :title="brand.alt"
          />
        </carousel>
      </div>
    </section>
    <!-- End Brands Section -->
    <!-- Footer -->
    <Footer />
    <!-- End footer -->
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import axios from 'axios';
import CustomMainModal from '@/components/Modals/CustomMainModal';
import Signin from '@/components/Signin/Signin';
import Register from '@/components/Register/Register';
import ResetPassword from '@/components/ResetPassword/ResetPassword';
import VerificationCode from '@/components/SearchJob/VerificationCode';
import VerificationCodeEmployer from './PublicPagesBase/VerificationCodeEmployer';
import FilePreview from '@/components/Home/FilePreview';
import carousel from 'vue-owl-carousel';
import PublicNavigation from '../components/Navigations/PublicNavigation';
import Spinner from '../components/common/LoadingSpinner/Spinner';
import titleMixin from '../mixins/titleMixin';
import { BRANDS } from '../constants';

import Footer from '@/components/Navigations/PublicFooter';
import { errorService } from '../services/errorService';

export default {
  mixins: [titleMixin],
  title() {
    return 'Community for IT Professionals and Employers | Jobshark';
  },
  description() {
    return 'Jobshark is a modern community for IT professionals and employers. We combine personal services with an easy-to-use interface.';
  },
  canonicalLink() {
    return 'https://jobshark.eu';
  },
  components: {
    Spinner,
    CustomMainModal,
    Signin,
    Register,
    ResetPassword,
    VerificationCode,
    PublicNavigation,
    VerificationCodeEmployer,
    carousel,
    Footer,
    FilePreview,
  },
  data: () => ({
    showForm: {
      formType: '',
      count: 0,
    },
    retoken: '',
    isLoading: false,
    modalTitle: '',
    showResetPassword: false,
    showLogin: false,
    showRegister: false,
    openEmailVerification: false,
    jobAds: [],
    promotedJobAds: [],
    sendLocation: [],
    keywords: [],
    locationsOptions: [],
    showModal: false,
    showModalJob: false,
    step: 1,
    showVerification: false,
    nextStep: false,
    validCity: false,
    validCountry: false,
    canPost: false,
    emailNotFalid: false,
    emailValidated: false,
    phoneValidated: false,
    brands: BRANDS,
  }),
  methods: {
    ...mapActions([
      'fetchAllJobResults',
      'retrieveEmployersDropdownCandidate',
      'retrieveCompetencesList',
      'searchLocationByName',
      'retrieveCitiesListByCountryId',
      'retrieveLanguagesList',
      'retrieveAllCountries',
    ]),

    slugify(text) {
      return text
        .toString()
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^\w\-]+/g, '')
        .replace(/\-\-+/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '');
    },
    showWorkPlace(data) {
      if (data === 1) {
        return 'Onsite';
      } else if (data === 2) {
        return 'Hybrid';
      } else {
        return 'Remote';
      }
    },
    showFormEvent(type) {
      this.showForm.formType = type;
      this.showForm.count++;
    },
    toggleForms() {
      this.showVerification = false;
    },

    getDefaultCountry() {
      axios
        .get(`${process.env.VUE_APP_API_URL}/common/address/getaddressbyip`, {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(({ data }) => {
          this.postFreeJob.countryName = data.country_name;
          this.postFreeJob.countryId = data.country_id;
          this.postFreeJob.phone_code = data.country_name;
          this.postFreeJob.phone = `${data.phone_code} `;
          this.postFreeJob.city = data.city_name;
          this.postFreeJob.cityId = data.city_id;
          this.postFreeJob.postal = data.city_postal_code;

          if (this.postFreeJob.countryId) {
            this.retrieveCitiesListByCountryId({ id: this.postFreeJob.countryId });
          }
        });
    },

    addCountryCode(code) {
      this.postFreeJob.phone_code = code.replace(/[0-9+]/g, '');
      this.postFreeJob.phone = code.substring(0, code.indexOf(' ')) + ' ';
    },

    validate(el) {
      if (el.target.required === true && el.target.value === '') {
        el.target.classList.add('is-invalid');
      } else {
        el.target.classList.remove('is-invalid');
      }

      if (el.target.type === 'email') {
        this.validateEmail(this.postFreeJob.email);
      }

      if (el.target.type === 'password' && el.target.value.length < 8) {
        el.target.classList.add('is-invalid');
      } else {
        el.target.classList.remove('is-invalid');
      }
    },

    validateEmail(email) {
      const emailRe = /^(([^<>()[\]\\.,;:#/\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      // const emailRe = /^(([^<>()\[\]\\.,;:#/\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (email.length > 0) {
        if (emailRe.test(email)) {
          this.postFreeJob.emailNotFalid = false;
          this.postFreeJob.emailValidated = true;
        } else {
          this.postFreeJob.emailNotFalid = true;
          this.postFreeJob.emailValidated = false;
        }
      }
    },

    fetchOptions(search, loading) {
      if (search.length < 3) {
        this.locationsOptions = [];
      }

      if (search.length >= 3) {
        loading(true);

        this.searchLocationByName(search)
          .then(response => {
            const citiesList = response.data.cities;
            const countriesList = response.data.countries;
            const concatedLists = [].concat(countriesList, citiesList);
            this.locationsOptions = concatedLists;
            loading(false);
          })
          .catch(err => {
            loading(false);
            this.$toasted.error(errorService(err), {
              theme: 'bubble',
              icon: 'fa-times-circle',
              position: 'bottom-right',
              duration: 8000,
            });
          });
      }
    },

    /*  fetchCitisByC(e) {
      this.postFreeJob.countryName = e.name;
      this.postFreeJob.countryId = e.id;
      this.retrieveCitiesListByCountryId({ id: this.postFreeJob.countryId });
      this.postFreeJob.city = '';
      this.postFreeJob.cityId = '';
    }, */
    searchJob() {
      localStorage.setItem('sKeyWords', JSON.stringify(this.keywords));
      localStorage.setItem('sLocation', JSON.stringify(this.sendLocation));
      this.$router.push('search-jobs');
    },
    openPostJob() {
      this.showModalJob = true;
    },

    fetchCitisByCountryId(e) {
      this.postFreeJob.city = '';
      this.postFreeJob.cityId = '';
      this.postFreeJob.countryName = e.name;
      this.postFreeJob.countryId = e.id;
      this.retrieveCitiesListByCountryId({ id: this.postFreeJob.countryId });
    },

    getCaptcha() {
      let vm = this;
      const REG = () => this.registerEmployer();
      grecaptcha
        .execute('6LdyDhspAAAAAJWVsgRkufJ8fAJBeSDpWDPUsvAn', { action: 'submit' })
        .then(function(token) {
          vm.reToken = token;
          REG();
        });
    },

    registerEmployer() {
      if (!this.postFreeJob.isAgree) {
        this.$toasted.error(
          `Please agree to Jobshark's General Conditions for Employers to register`,
          {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          },
        );
        return false;
      }

      this.isLoading = true;

      axios({
        method: 'post',
        url: `${process.env.VUE_APP_API_URL}/manager/auth/register`,
        data: {
          email: this.postFreeJob.email,
          password: this.postFreeJob.password,
          company_name: this.postFreeJob.companyName,
          first_name: this.postFreeJob.firstName,
          last_name: this.postFreeJob.lastName,
          city_id: this.postFreeJob.cityId,
          country_id: this.postFreeJob.countryId,
          street_address: this.postFreeJob.address,
          website: this.postFreeJob.corporateWebsite,
          phone_number: this.postFreeJob.phone,
          country_code: this.postFreeJob.phone_code,
          postal_code: this.postFreeJob.postal,
          privacy: this.postFreeJob.isAgree,
          'g-recaptcha-response': this.reToken,
          campaign_id: this.postFreeJob.campaign_id,
          campaign_medium: this.postFreeJob.campaign_medium,
          campaign_name: this.postFreeJob.campaign_name,
          campaign_source: this.postFreeJob.campaign_source,
        },
      })
        .then(response => {
          localStorage.setItem('uuid', response.data.id);

          this.showVerification = true;
          this.isLoading = false;
        })

        .catch(err => {
          this.isLoading = false;
          this.$toasted.error(`${err.response.data.message}`, {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        });
    },
    openModal(e) {
      this.showModal = true;

      if (e.target.id == 'login-btn') {
        this.modalTitle = 'Sign In';
        this.showLogin = true;
        this.showRegister = false;
        this.showResetPassword = false;
      } else if (e.target.id == 'register-btn') {
        this.modalTitle = 'Sign Up as Candidate';
        this.showLogin = false;
        this.showResetPassword = false;
        this.showRegister = true;
      } else if (e.target.id == 'register-link') {
        this.modalTitle = 'Sign Up as Candidate';
        this.showLogin = false;
        this.showResetPassword = false;
        this.showRegister = true;
      } else if (e.target.id == 'forgotten-password') {
        this.modalTitle = 'Reset Password';
        this.showRegister = false;
        this.showLogin = false;
        this.showResetPassword = true;
      } else if (e.target.id == 'already-have-account') {
        this.modalTitle = 'Sign In';
        this.showLogin = true;
        this.showRegister = false;
        this.showResetPassword = false;
      }
    },
    getLatestJobAds() {
      axios
        .get(`${process.env.VUE_APP_API_URL}/externalpages/topjobads`, {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(({ data }) => {
          this.jobAds = data;
        })
        .catch(({ error }) => {
          console.log(error);
        });
    },
    getPromotedJobs() {
      axios
        .get(`${process.env.VUE_APP_API_URL}/externalpages/promotedjobads`, {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(({ data }) => {
          this.promotedJobAds = data;
        })
        .catch(({ error }) => {
          console.log(error);
        });
    },
    employmentType(employment) {
      if (employment === 1) {
        return 'Employment';
      } else if (employment === 2) {
        return 'Self-employment';
      } else if (employment === 3) {
        return 'Employment / Self-Employment';
      }
    },
    getCampainParams() {
      if (this.$route.query.utm_id) {
        this.postFreeJob.campaign_id = this.$route.query.utm_id;
      }
      if (this.$route.query.utm_medium) {
        this.postFreeJob.campaign_medium = this.$route.query.utm_medium;
      }
      if (this.$route.query.utm_campaign) {
        this.postFreeJob.campaign_name = this.$route.query.utm_campaign;
      }
      if (this.$route.query.utm_source) {
        this.postFreeJob.campaign_source = this.$route.query.utm_source;
      }
    },
  },
  watch: {
    postFreeJob: {
      handler(val) {
        if (val.companyName && val.countryId && val.address && val.postal && val.cityId) {
          this.nextStep = true;
        } else {
          this.nextStep = false;
        }
        if (
          this.nextStep &&
          val.firstName &&
          val.lastName &&
          val.password.length >= 8 &&
          val.phone &&
          val.email.length > 0
        ) {
          this.canPost = true;
        } else {
          this.canPost = false;
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters([
      'getNextPage',
      'getTotalPages',
      'getCurrentPage',
      'getAllCountries',
      'allSearchJobResults',
      'getCompetencesFilterList',
      'getCitiesListByCountry',
      'getEmployersDropdownCandidate',
    ]),
  },
  mounted() {
    this.getLatestJobAds();
    this.getPromotedJobs();
    this.getCampainParams();
  },
};
</script>
<style lang="scss" scoped>
@import './src/assets/scss/_variables.scss';

.no-padding {
  padding-left: 8px;
  padding-top: 15px;
}

.container {
  max-width: 1320px;
}

.main-header {
  height: 70vh;
  background: url('../../public/img/homepage/header_home.png');
  background-size: cover;
  margin-top: 70px;

  .container {
    height: 70vh;
    flex-wrap: wrap;

    h1 {
      color: #fff;
      font-size: 2.5rem;
      width: 100%;

      span {
        display: block;
      }
    }

    .form-inline {
      width: 100%;

      .col-1-left {
        flex: 1;
        margin-right: 12px;
      }

      .col-2-middle {
        width: 45%;
      }

      .form-group {
        position: relative;
        width: 100%;
        display: block;

        i {
          position: absolute;
          top: 50%;
          transform: translate(0, -50%);
          right: 32px;
          color: #9b9b9b;
          font-size: 26px;
        }

        .form-control {
          border-radius: 8px;
          min-height: 65px;
          flex: 1;
          font-size: 18px;
          width: 100%;
          font-family: $font-family-sans-lato;
        }
      }

      .btn-secondary {
        height: 54px;
        border-radius: 8px;
        display: block;
        width: 100%;
        text-transform: uppercase;
      }

      a {
        display: block;
        color: #fff;
        text-decoration: none;
        font-size: 18px;
        margin-top: 10px;
      }
    }
  }
}

.latest-ads {
  padding: 60px 0;

  h2 {
    text-transform: uppercase;
    font-size: 21px;
    margin-bottom: 40px;
  }

  .single {
    padding: 5px;
    background: #fff;
    box-shadow: 0px 15px 35px #0000000d;
    margin-bottom: 20px;
    font-family: $font-family-sans-lato;

    img {
      width: 70px;
      height: 70px;
      max-width: 70px;
      object-fit: contain;
      object-position: center;
      overflow: hidden;
      margin-right: 12px;
      flex-shrink: 0;
    }

    .job-info {
      width: 30%;
      margin-right: 12px;

      a {
        display: block;
        text-decoration: none;

        &:first-of-type {
          font-size: 18px;
        }

        &:nth-of-type(2) {
          color: #424242;
          font-size: 16px;
        }
      }
    }

    .location {
      text-align: center;
      width: 130px;
      margin: 0 10px;

      a {
        text-decoration: none;
      }

      i {
        display: block;
        color: #afafaf;
        font-size: 18px;
        margin-bottom: 5px;
      }

      span {
        font-size: 12px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
        text-transform: uppercase;
      }
    }

    .tagline {
      text-align: right;
      width: 200px;

      a {
        display: inline-block;
        background: #f2f2f2;
        border-radius: 16px;
        color: #3e3e3e;
        border: 5px solid #fff;
        font-size: 13px;
        padding: 3px 8px;
        text-decoration: none;
        font-weight: 500;
      }
    }
  }
}

.pagination {
  a {
    color: #495057;
    font-size: 14px;
  }
}

.single-promoted {
  padding: 5px;
  background: #fff;
  box-shadow: 0px 15px 35px #0000000d;
  margin-bottom: 20px;
  font-family: $font-family-sans-lato;
  position: relative;
  text-decoration: none;

  img {
    width: 70px;
    height: 70px;
    flex-shrink: 0;
    object-fit: contain;
  }

  .single-job-info {
    margin-left: 12px;
    flex-wrap: wrap;

    span {
      &:first-of-type {
        display: block;
        width: 100%;

        a {
          text-decoration: none;
        }
      }

      &:nth-of-type(2) {
        display: block;

        a {
          color: #87859c;
          font-size: 14px;
          text-decoration: none;
        }
      }
    }
  }

  .location {
    position: absolute;
    top: 13px;
    right: 5px;
    font-size: 12px;
    color: #87859c;
  }

  .details {
    color: #424242;
    font-size: 14px;
  }
}

.mid-section {
  padding: 60px 0;
  background: hsl(23, 100%, 47%);
  color: #fff;
  margin-bottom: 40px;

  img {
    width: 56px;
    height: 65px;
    flex-shrink: 0;
    margin: 20px 20px 0 0;
  }

  h2 {
    text-align: center;
    text-transform: uppercase;
    margin-bottom: 30px;
  }

  p {
    text-align: center;
    font-family: $font-family-sans-lato;
    font-size: 18px;
  }

  .text-box {
    cursor: pointer;
    margin-top: 80px;
    width: 300px;
    position: relative;

    .text {
      h3 {
        text-transform: uppercase;
        font-size: 24px;
      }

      p {
        text-align: left;
        font-family: $font-family-sans-lato;
        font-size: 16px;
      }
    }

    span {
      position: absolute;
      display: inline-block;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      line-height: 40px;
      background: #424242;
      color: #fff;
      text-decoration: none;
      text-align: center;
      top: 50%;
      right: -35px;
      transform: translate(0, -50%);
    }
  }
}

.brands {
  padding: 50px 0;

  h3 {
    text-transform: uppercase;
    text-align: center;
    font-size: 34px;
    margin-bottom: 50px;
  }
  img {
    filter: grayscale(100%);
    &:hover {
      filter: grayscale(0);
    }
  }
}

.form-group.required {
  position: relative;

  &:after {
    content: '*';
    font-size: 22px;
    position: absolute;
    top: 0px;
    right: 26px;
    color: red;
    opacity: 0.6;
  }
}

.form-group.required-right {
  position: relative;

  &:after {
    content: '*';
    font-size: 22px;
    position: absolute;
    top: 0px;
    right: 10px;
    color: red;
    opacity: 0.6;
  }
}

.form-group.required-fixed-right {
  position: relative;

  &:after {
    content: '*';
    font-size: 22px;
    position: absolute;
    top: 0px;
    right: 6px;
    color: red;
    opacity: 0.6;
  }
}

.form-group.required-fixed-drop {
  position: relative;

  &:after {
    content: '*';
    font-size: 22px;
    position: absolute;
    top: 0px;
    right: 25px;
    color: red;
    opacity: 0.6;
  }
}

.footer {
  width: 100%;
  height: 350px;
  background: url('../../public/img/homepage/footer-bg.png');
  background-size: cover;
  text-transform: uppercase;
  color: #fff;

  a {
    text-decoration: none;
    color: #fff;
  }

  .list-inline {
    li {
      position: relative;
      margin-right: 25px;
      font-size: 14px;

      &:after {
        content: '';
        position: absolute;
        right: -13px;
        top: 0;
        width: 1px;
        height: 100%;
        background: #fff;
      }

      &.last {
        &:after {
          display: none;
        }
      }
    }
  }
}

@media only screen and (max-width: 992px) {
}

@media only screen and (max-width: 768px) {
  .main-header {
    height: auto;

    .container {
      height: auto;
      padding: 30px 20px;

      h1 {
        font-size: 2rem;
      }

      .form-inline {
        .form-group {
          width: 100% !important;
          margin: 12px 0px;

          &:first-of-type {
            width: 100%;
          }

          .form-control {
            min-height: 55px;
          }

          .btn-secondary {
            height: 55px;
          }
        }
      }

      a {
        width: 100%;
      }
    }
  }
}

@media only screen and (max-width: 576px) {
  .main-header {
    .w-50 {
      width: 100% !important;
      margin-bottom: 12px;
    }
    margin-top: 60px;
    .base-search-two {
      display: block !important;
      .col-1-left {
        margin: 0 0 12px 0 !important;
      }
      .col-2-middle {
        display: block !important;
        width: 100% !important;
      }
    }
  }

  .latest-ads {
    .single {
      flex-wrap: wrap;

      img {
        display: none;
      }

      .job-info {
        width: 100%;
        margin-bottom: 12px;
      }

      .tagline {
        margin: 12px 0 0 0 !important;
        width: 100%;
        text-align: center;
      }

      .location {
        margin: 0;
        color: #666;
        width: 48%;
        text-align: left;

        i {
          display: none;
        }

        &:nth-last-of-type(2) {
          text-align: right;
        }
      }
    }
  }

  .mid-section {
    .mobile-wrap {
      flex-wrap: wrap;
    }
  }
}
</style>
